export default __webpack_public_path__ + "static/media/Paycor-DeveloperPortal.75b73adc.svg";